import apiClient from './apiClient';

const API_BASE_URL = process.env.REACT_APP_API_URL;

class JiraDataService {
  async getProjects() {
    try {
      return await apiClient.get('/jira/projects');
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch projects');
    }
  }

  async getProjectStartDate(projectKey) {
    try {
      return await apiClient.get('/jira/project_start_date', {
        params: { project_key: projectKey },
      });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch project start date');
    }
  }  

  async getIssues(projectKey = null, maxResults = 50) {
    try {
      const params = { max_results: maxResults };
      if (projectKey) {
        params.project_key = projectKey;
      }
      return await apiClient.get('/jira/issues', { params });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch issues');
    }
  }

  async getUsers(projectKey = null, maxResults = 50) {
    try {
      const params = { max_results: maxResults };
      if (projectKey) {
        params.project_key = projectKey;
      }
      return await apiClient.get('/jira/users', { params });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch users');
    }
  }

  async getProjectMembers(projectKey, maxResults = 50) {
    try {
      const params = { project_key: projectKey, max_results: maxResults };
      return await apiClient.get('/jira/project_members', { params });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch project members');
    }
  }

  async searchIssues(jql, maxResults = 50) {
    try {
      const params = { jql, max_results: maxResults };
      return await apiClient.get('/jira/search', { params });
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to search issues');
    }
  }
}

export const jiraDataService = new JiraDataService();